import React from 'react';
import styled from 'styled-components';

export default props => {

    if(props.loaded) return null;

    return(
        <Loader>
            <div className="spinner">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
            </div>
        </Loader>
    );
}

const Loader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    .spinner {
        width: 70px;
        text-align: center;
    }

    .spinner > div {
        width: 12px;
        height: 12px;
        background-color: #A61717;

        border-radius: 100%;
        display: inline-block;
        margin: 0 1px;
        -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .spinner .bounce1 {
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
    }

    .spinner .bounce2 {
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
    }

    @-webkit-keyframes sk-bouncedelay {
        0%, 80%, 100% { -webkit-transform: scale(0); opacity: 0; }
        40% { -webkit-transform: scale(1.0); opacity: 1 }
    }

    @keyframes sk-bouncedelay {
        0%, 80%, 100% { 
            -webkit-transform: scale(0);
            transform: scale(0);
            opacity: 0;
        } 40% { 
            -webkit-transform: scale(1.0);
            transform: scale(1.0);
            opacity: 1;
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/Loader.js